import * as React from "react";
import type { SVGProps } from "react";
const SvgTv = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.78 3H4.22C2.45 3 1 4.35 1 6v9c0 1.65 1.45 3 3.22 3H11v1H8c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1h-3v-1h6.78c1.78 0 3.22-1.35 3.22-3V6c0-1.65-1.45-3-3.22-3M21 15c0 .55-.55 1-1.22 1H4.22C3.55 16 3 15.55 3 15V6c0-.55.55-1 1.22-1h15.56c.67 0 1.22.45 1.22 1z"
    />
  </svg>
);
export default SvgTv;
